import React, { } from 'react';

export default function NotFound() {
    return (
        <div className="ui grid middle aligned segment grey inverted">
            <div className="ui column center aligned">
                <div className="ui inverted statistic">
                    <div className="value">404</div>
                    <div className="label">Page not found</div>
                </div>

            </div>
        </div>
    )
}
